import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ArtToothForDiagram } from '../../models';
import { RxIntuitiveArtToothComponent } from '../rx-intuitive-art-tooth/rx-intuitive-art-tooth.component';

@Component({
	selector: 'rx-intuitive-art-teeth-diagram',
	templateUrl: './rx-intuitive-art-teeth-diagram.component.html',
	styleUrls: ['./rx-intuitive-art-teeth-diagram.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, RxIntuitiveArtToothComponent],
	host: {
		'[attr.tabindex]': 'hostTabIndex'
	}
})
export class RxIntuitiveArtTeethDiagramComponent {
	readonly hostTabIndex = '-1';

	@Input() upperJaw: ArtToothForDiagram[] = [];
	@Input() lowerJaw: ArtToothForDiagram[] = [];
	/** When true, tooth taps do not change selection (shell / teethDiagram read-only). */
	@Input() chartReadOnly = false;

	@Output() toothClicked = new EventEmitter<number>();
	@Output() resetSelectedRequested = new EventEmitter<void>();

	getDisplayNumber(tooth: ArtToothForDiagram): string | number {
		return tooth.toothNumberInSystem;
	}

	onToothClicked(toothId: number): void {
		if (this.chartReadOnly) {
			return;
		}

		this.toothClicked.emit(toothId);
	}

	onResetSelectedRequested(): void {
		if (this.chartReadOnly) {
			return;
		}

		this.resetSelectedRequested.emit();
	}

	toothIdTrackBy(index: number, tooth: ArtToothForDiagram): number {
		return tooth.toothId;
	}
}
